module.exports = __webpack_public_path__ + "img/draw_btn.709e2b49.png";